/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件工具自动生成，请勿直接修改！！！ */

// @ts-ignore

import request from '@/utils/request/index';
/**
 * 接口 [查询管理员列表↗](https://yapi.fenxianglife.com/project/379/interface/api/43828) 的 **请求函数**
 *
 * @分类 [管理员相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10161)
 * @请求头 `POST /admin/agent/list`
 * @更新时间 `2023-09-13 13:55:02`
 */
export const feimaChatAdminAgentList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatAdminAgentListRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatAdminAgentListResponse, OT>>(
    '/admin/agent/list',
    'POST',
    data,
    options
  );

/**
 * 接口 [查询可切换用户列表↗](https://yapi.fenxianglife.com/project/379/interface/api/43864) 的 **请求函数**
 *
 * @分类 [管理员相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10161)
 * @请求头 `POST /admin/principal/list`
 * @更新时间 `2023-09-13 18:45:07`
 */
export const feimaChatAdminPrincipalList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatAdminPrincipalListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatAdminPrincipalListResponse, OT>
  >('/admin/principal/list', 'POST', data, options);

/**
 * 接口 [管理员主动取消↗](https://yapi.fenxianglife.com/project/379/interface/api/43870) 的 **请求函数**
 *
 * @分类 [管理员相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10161)
 * @请求头 `POST /admin/agent/terminate`
 * @更新时间 `2023-09-13 14:34:17`
 */
export const feimaChatAdminAgentTerminate = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatAdminAgentTerminateRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatAdminAgentTerminateResponse, OT>
  >('/admin/agent/terminate', 'POST', data, options);

/**
 * 接口 [委托人取消管理员↗](https://yapi.fenxianglife.com/project/379/interface/api/43876) 的 **请求函数**
 *
 * @分类 [管理员相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10161)
 * @请求头 `POST /admin/principal/terminate`
 * @更新时间 `2023-09-14 17:45:52`
 */
export const feimaChatAdminPrincipalTerminate = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatAdminPrincipalTerminateRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatAdminPrincipalTerminateResponse, OT>
  >('/admin/principal/terminate', 'POST', data, options);

/**
 * 接口 [切换身份↗](https://yapi.fenxianglife.com/project/379/interface/api/43882) 的 **请求函数**
 *
 * @分类 [管理员相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10161)
 * @请求头 `POST /admin/agent/switch`
 * @更新时间 `2023-09-13 14:38:23`
 */
export const feimaChatAdminAgentSwitch = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatAdminAgentSwitchRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatAdminAgentSwitchResponse, OT>>(
    '/admin/agent/switch',
    'POST',
    data,
    options
  );

/**
 * 接口 [获取邀请信息↗](https://yapi.fenxianglife.com/project/379/interface/api/43888) 的 **请求函数**
 *
 * @分类 [管理员相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10161)
 * @请求头 `POST /admin/invitation/info`
 * @更新时间 `2023-09-13 14:43:33`
 */
export const feimaChatAdminInvitationInfo = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatAdminInvitationInfoRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatAdminInvitationInfoResponse, OT>
  >('/admin/invitation/info', 'POST', data, options);

/**
 * 接口 [接受邀请↗](https://yapi.fenxianglife.com/project/379/interface/api/43894) 的 **请求函数**
 *
 * @分类 [管理员相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10161)
 * @请求头 `POST /admin/invitation/accept`
 * @更新时间 `2023-09-13 14:48:04`
 */
export const feimaChatAdminInvitationAccept = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatAdminInvitationAcceptRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatAdminInvitationAcceptResponse, OT>
  >('/admin/invitation/accept', 'POST', data, options);

/**
 * 接口 [生成邀请码↗](https://yapi.fenxianglife.com/project/379/interface/api/43900) 的 **请求函数**
 *
 * @分类 [管理员相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10161)
 * @请求头 `POST /admin/invitation/generateCode`
 * @更新时间 `2023-09-13 14:50:00`
 */
export const feimaChatAdminInvitationGenerateCode = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatAdminInvitationGenerateCodeRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatAdminInvitationGenerateCodeResponse,
      OT
    >
  >('/admin/invitation/generateCode', 'POST', data, options);

export interface AgentCategoryStats {
  primaryCount: number;
  secondaryCount: number;
  agentCount: number;
}

export interface AgentCategorySecondaryResult {
  id: number;
  code: string;
  name: string;
  parentId: number;
  agentCount: number;
  delFlag: number;
}

export interface AgentCategoryPrimaryResult {
  id: number;
  code: string;
  name: string;
  secondaryCount: number;
  agentCount: number;
  secondaryList?: AgentCategorySecondaryResult[] | null;
}

export interface AgentCategoryPrimaryListRequest {
  keyword?: string;
  page?: number;
  size?: number;
}

export type AgentCategoryCreateRequest =
  | {
      level: 1;
      name: string;
    }
  | {
      level: 2;
      name: string;
      parentId: number;
    };

export interface AgentCategoryUpdateRequest {
  id: number;
  name: string;
}

export interface AgentCategoryDeleteRequest {
  id: number;
}

export const feimaChatSuperAdminGetAgentCategoryStats = (options?: any) =>
  request<AgentCategoryStats>(
    '/admin/agent/category/stats',
    'POST',
    {},
    options
  );

export const feimaChatSuperAdminListAgentPrimaryCategories = (
  data: AgentCategoryPrimaryListRequest,
  options?: any
) =>
  request<AgentCategoryPrimaryResult[]>(
    '/admin/agent/category/primary/list',
    'POST',
    data,
    {
      ...options,
      params: {
        ...(options?.params || {}),
        keyword: data.keyword || '',
      },
    }
  );

export const feimaChatSuperAdminCreateAgentCategory = (
  data: AgentCategoryCreateRequest,
  options?: any
) =>
  request<void>(
    '/admin/agent/category/create',
    'POST',
    data,
    options
  );

export const feimaChatSuperAdminUpdateAgentCategory = (
  data: AgentCategoryUpdateRequest,
  options?: any
) =>
  request<void>(
    '/admin/agent/category/update',
    'POST',
    data,
    options
  );

export const feimaChatSuperAdminDeleteAgentCategory = (
  data: AgentCategoryDeleteRequest,
  options?: any
) =>
  request<void>(
    `/admin/agent/category/delete?id=${data.id}`,
    'POST',
    {},
    options
  );

/* prettier-ignore-end */
